export const ErrorDisplay = ({ error }: { error: any }) => {
  if (error instanceof Error) {
    return <div className="ErrorDisplay">{error.message}</div>;
  } else if (typeof error === "string") {
    return <div className="ErrorDisplay">{error}</div>;
  } else {
    return <div className="ErrorDisplay">{JSON.stringify(error, null, 2)}</div>;
  }
};
